import { useAnalyticsTrack } from '@chr/react-analytics';

export interface DocumentActivity {
  numberOfDocuments: number;
  buttonText: string;
  activityResult: 'Upload' | 'Download' | 'Email';
  activityResponseTime: number;
  typeOfDocument: string;
}

export const useAnalytics = () => {
  const track = useAnalyticsTrack();

  const trackButtonClick = (label: string, tabName?: string): void => {
    track({
      event: 'userActions',
      infoUI: {
        label: createLabel(label, tabName),
        name: 'button',
        type: 'click'
      }
    });
  }

  const trackEvent = (label: string, name: string, type: string): void => {
    track({
      event: 'userActions',
      infoUI: {
        label: label,
        name: name,
        type: type
      }
    });
  }

  const createLabel = (label: string, tabName?: string): string => {
    return tabName !== undefined ? `${tabName} - ${label}` : label;
  }

  const trackDocActivity = (docActivity: DocumentActivity): void => {
    track({ event: 'documentActivity', data: { ...docActivity } });
  }

  return {
    trackEvent,
    trackButtonClick,
    trackDocActivity,
  };
}
